import {GET_DETAILS, GET_ERRORS} from "../storeconstants";

export default {
    [GET_ERRORS](state) {
        return state.errors;
    },
    [GET_DETAILS](state) {
        return state.details;
    },
}